/**
 * Warnings: Grow checks the coming week against every plant and emails the
 * afternoon before. The real warning email Grow sends leads
 * (public/landing/warning-email.jpg), beside the gardener's pain about finding
 * out too late, the heading and the first sentence of the body; the body's
 * second sentence (the chores) shows only on a wide screen, where it fits.
 *
 * Words (en/es): landing.warnings.*.
 *
 * @module Warnings
 */

import React from 'react';
import { CloudLightning } from 'lucide-react';
import { useTranslation } from '@/shared/hooks/useTranslation';
import { FeatureBlock } from '../components/FeatureBlock';

/** The warnings section. */
export const Warnings: React.FC = () => {
  const { reactTranslate: t } = useTranslation();
  return (
    <FeatureBlock
      icon={<CloudLightning className="h-8 w-8" strokeWidth={1.75} />}
      pain={t('landing.warnings.pain')}
      title={t('landing.warnings.title')}
      line={t('landing.warnings.body')}
      more={t('landing.warnings.bodyMore')}
      evidence={(
        <img src="/landing/warning-email.jpg" alt={t('landing.warnings.emailAlt')} loading="lazy" className="w-full rounded-2xl border shadow-xl" />
      )}
    />
  );
};
